/* eslint-disable no-case-declarations */
import { combineReducers } from 'redux';
import {
  FETCH_JOBS_LIST_REQUEST,
  FETCH_JOBS_LIST_SUCCESS,
  FETCH_JOBS_LIST_FAILURE,
  CHANGE_JOB_TYPE,
  CHANGE_JOB_INFO,
  SET_JOB_SELECTED_ERRORS,
  CLEAR_JOB_SELECTED_ERRORS,
  CLEAR_JOBS_DATA,
  ADD_A_JOB_REQUEST,
  ADD_A_JOB_FAILURE,
  ADD_A_JOB_SUCCESS,
  FETCH_JOB_BY_ID_SUCCESS,
} from '../../constants/ActionTypes';

const updatedJobsList = (action) => {
  const data =
    action && action.data && action.data.data ? action.data.data : {};

  let { data: dataToUpdate = [] } = data;

  dataToUpdate = dataToUpdate.map((d) => Object.assign(d, { name: d.jobName }));

  data.data = dataToUpdate;

  return data;
};

const list = (
  state = { data: {}, isFetching: false, errorMessage: null },
  action
) => {
  switch (action.type) {
    case FETCH_JOBS_LIST_REQUEST:
      return { ...state, isFetching: true, errorMessage: null };
    case FETCH_JOBS_LIST_SUCCESS:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: updatedJobsList(action),
      };
    case FETCH_JOBS_LIST_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.message };
    case CLEAR_JOBS_DATA:
      return { data: {}, isFetching: false, errorMessage: null };
    default:
      return state;
  }
};

const selected = (
  state = {
    current: {},
    jobStat: null,
    errors: {},
    loading: false,
  },
  action
) => {
  switch (action.type) {
    case CHANGE_JOB_TYPE:
      return {
        ...state,
        current: action.data,
      };
    case CHANGE_JOB_INFO:
      const updateCurrunt = state.current;

      updateCurrunt[action.field] = action.value;

      return {
        ...state,
        current: updateCurrunt,
      };
    case SET_JOB_SELECTED_ERRORS:
      return {
        ...state,
        errors: action.data,
      };
    case CLEAR_JOB_SELECTED_ERRORS:
      return {
        ...state,
        errors: {},
      };
    case CLEAR_JOBS_DATA:
      return {
        current: {},
        errors: {},
        jobStat: null,
      };
    case ADD_A_JOB_REQUEST:
      return {
        ...state,
        errors: {},
        loading: true,
      };

    case ADD_A_JOB_FAILURE:
      return {
        ...state,
        errors: action.data,
        loading: false,
      };
    case ADD_A_JOB_SUCCESS:
      return {
        ...state,
        loading: false,
        current: {},
      };
    case FETCH_JOB_BY_ID_SUCCESS:
      return {
        ...state,
        jobStat: action.data,
      };
    default:
      return state;
  }
};

const jobs = combineReducers({
  list,
  selected,
});

export default jobs;
